export const data2=[

    {
        head:"Hot",
        day:"0 day ago",
        pos:"Java Back-end Developer",
        com:"Sunil Kumar",
        img1:"u",
        cty:"Bangalore +2",
        img2:"t",
        ex:" 2 to 7 years",
        ft1:"Be an Early Applicant",
        ft2:"Regular",
        vac:8,
        id:1
        
    },
    {
        head:"Hot",
        day:"0 day ago",
        pos:"Android Developer",
        com:"CRS Cost Recover Solutions",
        img1:"u",
        cty:"Mumbai",
        img2:"t",
        ex:" 0 to 2 years",
        ft1:"Be an Early Applicant",
        ft2:"Regular",
        vac:10,
        id:2
        

    },
    {
        head:"Hot",
        day:"0 day ago",
        pos:"Social Media Expert",
        com:"    Orcapod Consulting Service Pvt Ltd",
        img1:"u",
        cty:"Noida",
        img2:"t",
        ex:" 1 to 3 years",
        ft1:"Be an Early Applicant",
        ft2:"Regular",
        vac:11,
        id:3

    },
    {
        head:"Hot",
        day:"0 day ago",
        pos:"Net Developer",
        com:"CRS Cost Recover Solutions",
        img1:"u",
        cty:"Mumbai",
        img2:"t",
        ex:" 1 to 2 years",
        ft1:"Be an Early Applicant",
        ft2:"Regular",
        vac:10,
        id:4

    },
    {
        head:"Hot",
        day:"0 day ago",
        pos:"Seo Consultant",
        com:"Orcapod Consulting Service Pvt Ltd",
        img1:"u",
        cty:"All India",
        img2:"t",
        ex:" 2 to 5 years",
        ft1:"Be an Early Applicant",
        ft2:"Regular",
        vac:11,
        id:5

    },
    
]